// ─── AutoChinBot · KN2 — TMA50-cross conversation controller ───
// Turns task4's "nến cắt TMA50" (TMA50 cross) detection into the interactive
// KN2 conversation on Telegram.
//
// Design (agreed with the user):
//   • Triggered by task4 — every detected TMA50 cross starts a KN2.
//   • The whole decision tree (TMA "mềm mại chưa?" + the shared [Vào lệnh]
//     entry) lives in the `telegram-bot` edge function; this controller only
//     sends the KN2 init message when a cross appears.
//   • IT RUNS IN THE BROWSER (same as task1–task6) — the app must be open for
//     the init to go out, consistent with the rest of the pipeline.
//   • No "nhắc lại" schedule for KN2 (the case has no repeat branch).

import telegramBot from '@/lib/telegram-bot-client';
import type { AutoChinTaskEvent } from '@/lib/autochin-etask-engine';

export class AutoChinKn2Controller {
  private started = false;

  // ─── Lifecycle ──────────────────────────────────────────────

  start(): void {
    this.started = true;
  }

  stop(): void {
    this.started = false;
  }

  // ─── task4 → KN2 init ───────────────────────────────────────

  /** task4 detected a candle crossing TMA50 → start the KN2 conversation. */
  async notifyTma50Cross(e: AutoChinTaskEvent): Promise<void> {
    if (!this.started) return;
    const crossDir: 'UP' | 'DOWN' = e.crossDir === 'DOWN' ? 'DOWN' : 'UP';
    try {
      await telegramBot.sendKn2({
        symbol: e.symbolName,
        symbol_id: e.symbolId,
        cross_dir: crossDir,
      });
    } catch {
      /* best-effort — the next cross will try again */
    }
  }
}